import Leaderboards from './Leaderboards'

export default { Leaderboards }
